<form [formGroup]="form" class="row">
  <div class="col-12">
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Nº de Sake</mat-label>
      <input type="number" formControlName="numero_sake" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Nombre Cliente</mat-label>
      <input formControlName="nombre_cliente" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Fecha Creación</mat-label>
      <input type="date" formControlName="fecha_creacion" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Fecha Asignación</mat-label>
      <input type="date" formControlName="fecha_asignacion" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Fecha Solución</mat-label>
      <input type="date" formControlName="fecha_solucion" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Canal Utilizado</mat-label>
      <input formControlName="canal_utilizado" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Unidad Responsable</mat-label>
      <input formControlName="unidad_responsable" matInput />
    </mat-form-field>
    <mat-form-field appearance="outline" class="col-4">
      <mat-label>Centro Costo</mat-label>
      <input formControlName="centro_costo" matInput />
    </mat-form-field>
  </div>
</form>
<h2>TRANSFERENCIAS</h2>
<section class="form">
  <hr />
  <form [formGroup]="formTable" class="form_table" (ngSubmit)="addData()">
    <mat-form-field appearance="outline">
      <mat-label>Monto Reclamado *</mat-label>
      <input
        Currency
        type="number"
        formControlName="monto_reclamado"
        matInput
      />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Monto Reclamado *"
      [ngClass]="{error: verificateInput('monto_reclamado')}">
      <input Currency type="number" placeholder="Monto Reclamado" formControlName="monto_reclamado">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Comisión *</mat-label>
      <input Currency type="number" formControlName="comision" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Comisión *"
      [ngClass]="{error: verificateInput('comision')}">
      <input Currency type="number" placeholder="Comisión" formControlName="comision">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Cuenta Origen *</mat-label>
      <input
        min="20"
        max="20"
        type="number"
        formControlName="cuenta_origen"
        matInput
      />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Cuenta Origen *"
      [ngClass]="{error: verificateInput('cuenta_origen')}">
      <input min="20" max="20" type="text" placeholder="Cuenta Origen" formControlName="cuenta_origen">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Cuenta de los Fondos Fraudulentos *</mat-label>
      <input
        min="20"
        max="20"
        type="number"
        formControlName="cuenta_fondos_fraudulentos"
        matInput
      />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Cuenta de los Fondos Fraudulentos *"
      [ngClass]="{error: verificateInput('cuenta_fondos_fraudulentos')}">
      <input min="20" max="20" type="text" placeholder="Cuenta de los Fondos Fraudulentos" formControlName="cuenta_fondos_fraudulentos">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Beneficiario *</mat-label>
      <input type="text" formControlName="beneficiario" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Beneficiario *"
      [ngClass]="{error: verificateInput('beneficiario')}">
      <input type="text" placeholder="Beneficiario" formControlName="beneficiario">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>C.I. / RIF *</mat-label>
      <input ciRif type="text" formControlName="ci_rif" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="C.I. / RIF *"
      [ngClass]="{error: verificateInput('ci_rif')}">
      <input ciRif type="text" placeholder="C.I. / RIF" formControlName="ci_rif">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Código de Oficina *</mat-label>
      <input type="number" formControlName="codigo_oficina" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Código de Oficina *"
      [ngClass]="{error: verificateInput('codigo_oficina')}">
      <input type="number" placeholder="Código de Oficina" formControlName="codigo_oficina">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Oficina Apertura *</mat-label>
      <input type="text" formControlName="oficina_apertura" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Oficina Apertura *"
      [ngClass]="{error: verificateInput('oficina_apertura')}">
      <input type="text" placeholder="Oficina Apertura" formControlName="oficina_apertura">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Fecha de Apertura *</mat-label>
      <input type="date" formControlName="fecha_apertura" matInput />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Fecha de Apertura *"
      [ngClass]="{error: verificateInput('fecha_apertura')}">
      <input type="text" placeholder="Fecha de Apertura" formControlName="fecha_apertura" onfocus="(this.type='date')">
    </div> -->
    <mat-form-field appearance="outline">
      <mat-label>Fecha de Ocurrencias *</mat-label>
      <input
        type="datetime-local"
        formControlName="fecha_ocurrencias"
        matInput
      />
    </mat-form-field>
    <!-- <div class="style-input-default input_table" data-text="Fecha de Ocurrencias *"
      [ngClass]="{error: verificateInput('fecha_ocurrencias')}">
      <input type="text" placeholder="Fecha de Ocurrencias" formControlName="fecha_ocurrencias"
        onfocus="(this.type='datetime-local')">
    </div> -->
    <button
      type="submit"
      *ngIf="!status"
      [disabled]="formTable.invalid || submit"
      style="width: 100%"
    >
      Aceptar
    </button>
  </form>
</section>

<div class="task_content_table">
  <table mat-table #dataTable [dataSource]="dataSource" class="task_table">
    <ng-container matColumnDef="Fecha de Ocurrencias">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Fecha de Ocurrencias
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.fecha_ocurrencias }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Monto Reclamado">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Monto Reclamado
      </th>
      <td mat-cell *matCellDef="let element">{{ element.monto_reclamado }}</td>
    </ng-container>

    <ng-container matColumnDef="Comisión">
      <th class="header-options" mat-header-cell *matHeaderCellDef>Comisión</th>
      <td mat-cell *matCellDef="let element">{{ element.comision }}</td>
    </ng-container>

    <ng-container matColumnDef="Cuenta Origen">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Cuenta Origen
      </th>
      <td mat-cell *matCellDef="let element">{{ element.cuenta_origen }}</td>
    </ng-container>

    <ng-container matColumnDef="Cuenta de los Fondos Fraudulentos">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Cuenta de los Fondos Fraudulentos
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.cuenta_fondos_fraudulentos }}
      </td>
    </ng-container>

    <ng-container matColumnDef="Beneficiario">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Beneficiario
      </th>
      <td mat-cell *matCellDef="let element">{{ element.beneficiario }}</td>
    </ng-container>

    <ng-container matColumnDef="C.I. / RIF">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        C.I. / RIF
      </th>
      <td mat-cell *matCellDef="let element">{{ element.ci_rif }}</td>
    </ng-container>

    <ng-container matColumnDef="Fecha de Apertura">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Fecha de Apertura
      </th>
      <td mat-cell *matCellDef="let element">{{ element.fecha_apertura }}</td>
    </ng-container>

    <ng-container matColumnDef="Código de Oficina">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Código de Oficina
      </th>
      <td mat-cell *matCellDef="let element">{{ element.codigo_oficina }}</td>
    </ng-container>

    <ng-container matColumnDef="Oficina Apertura">
      <th class="header-options" mat-header-cell *matHeaderCellDef>
        Oficina Apertura
      </th>
      <td mat-cell *matCellDef="let element">{{ element.oficina_apertura }}</td>
    </ng-container>

    <ng-container matColumnDef="Opciones">
      <th class="header-options" mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let element; let i = index">
        <div class="options">
          <button class="delete" (click)="removeData(i)">
            <i class="fas fa-times"></i>
          </button>
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>
</div>
<mat-paginator
  [pageSizeOptions]="[5, 10, 25, 50, 100]"
  [pageSize]="5"
  [showFirstLastButtons]
></mat-paginator>
